import { Truck, RefreshCw, ShieldCheck, Star } from "lucide-react";

/**
 * SRC-styled 4-column trust bar that sits under the hero. Content comes
 * from the template config so different store types show different
 * guarantees (e.g. skincare stores show "Cruelty-Free" instead of "500gsm").
 */
const ICONS = { truck: Truck, refresh: RefreshCw, shield: ShieldCheck, star: Star };
const DEFAULTS = [
  { icon: Truck, title: "Free Shipping", sub: "On orders over $100" },
  { icon: RefreshCw, title: "30-Day Returns", sub: "No questions asked" },
  { icon: ShieldCheck, title: "Secure Checkout", sub: "256-bit SSL encryption" },
  { icon: Star, title: "Rated 4.8 / 5", sub: "From 6,500+ reviews" },
];

export default function TrustBar({ items }) {
  const rows = (items && items.length ? items : DEFAULTS).map((i) => ({
    ...i,
    icon: typeof i.icon === "string" ? (ICONS[i.icon] || Star) : i.icon,
  }));
  return (
    <section data-testid="trust-bar" className="border-y border-neutral-200 bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {rows.map(({ icon: Icon, title, sub }) => (
          <div key={title} className="flex items-start gap-3">
            <Icon className="w-6 h-6 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
            <div>
              <p className="font-heading font-semibold text-sm">{title}</p>
              <p className="text-xs text-neutral-500 mt-0.5">{sub}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
